import {createLazyFileRoute} from '@tanstack/react-router'

import Chat from '@/views/Chat/Chat'

export const Route = createLazyFileRoute('/chat/')({
  component: Chat,
})
